import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getAdminVisibleBodyPhotos } from './api';
import { bodyPhotoKeys } from './keys';

export const useAdminVisibleBodyPhotos = ({
    centerId,
    memberId,
    enabled = true,
}: {
    centerId: string;
    memberId: string;
    enabled?: boolean;
}) => {
    const queryEnabled = enabled && !!centerId && !!memberId;
    const query = useQuery({
        queryKey: bodyPhotoKeys.member(centerId, memberId),
        queryFn: () => getAdminVisibleBodyPhotos({ centerId, memberId }),
        enabled: queryEnabled,
        select: (result) => result.data.photos,
        staleTime: 60 * 1000,
        cacheTime: 0,
        refetchInterval: 5 * 60 * 1000,
        refetchOnWindowFocus: true,
        retry: (failureCount, error: any) =>
            (error?.status ?? error?.response?.status) !== 403 && failureCount < 1,
    });
    const removeQuery = query.remove;

    useEffect(() => {
        if (!queryEnabled) removeQuery();
    }, [queryEnabled, removeQuery]);

    return query;
};
